import { useState } from "react";
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import moment from "moment";
import { IoMdArrowDropdownCircle, IoMdArrowDropupCircle  } from "react-icons/io";

import ExpandablePanel from '../../components/ExpandablePanel';
import { deadlineStatusEnum, isTaskCancelled, isTaskFinished, taskSizesEnum, taskStatusEnum, toolbarActions  } from '../../services/EnumsService';
import { taskStart, taskCancel, taskFinish } from "../../api/tasks.api";
import { subtaskOrder } from "../../api/subtask.api";
import ToolbarComponent from '../toolbar/ToolbarComponent';
import ToolbarOptionComponent from '../toolbar/ToolbarOptionComponent';
import { TaskModal } from '../Task/TaskModal';
import { SubtaskModal } from "../Subtask/SubtaskModal";
import ExpandableSubtaskComponent from "../Subtask/ExpandableSubtaskComponent";
import { WorklogModal } from "../Worklog/WorklogModal";
import WorklogComponent from "../Worklog/WorklogComponent";
import TaskResourceModal from './TaskResourceModal';
import TaskResourceComponenet from './TaskResourceComponent'
import { showError } from "../../services/toastServices";
import { CategoryData } from "../../pages/Category/CategoryWrapper";
import { BulkSubtaskModal } from "../Subtask/BulkSubtaskModal";

export default function ExpandableTaskComponent({task, isFirst, isLast, expanded, onToggle}) {
    const [showTaskModal, setShowTaskModal] = useState(false)
    const [showSubtaskModal, setShowSubtaskModal] = useState(false)
    const [showBulkSubtasksModal, setShowBulkSubtasksModal] = useState(false)
    const [showWorklogModal, setShowWorklogModal] = useState(false)
    const [showTaskResourceModal, setShowTaskResourceModal] = useState(false)
    const [expandedSubtaskId, setExpandedSubtaskId] = useState(null)
    const [dragSubtaskId, setDragSubtaskId] = useState(null)
    const [dragOverSubtaskId, setDragOverSubtaskId] = useState(null)
    const [isSubtaskDragging, setIsSubtaskDragging] = useState(false)
    const [isSubtaskDragOverTask, setIsSubtaskDragOverTask] = useState(false)
    
    // Usar CategoryData solo si está disponible
    const categoryContext = CategoryData();
    const category = categoryContext?.category;
    const refreshProjectsCategory = categoryContext?.refreshProjectsCategory || (() => {});
    

    const editTaskAction = (()=>{
        setShowTaskModal(true)
    })
    const editTaskCloseAction = (()=>{
        setShowTaskModal(false)
    })
    const createSubtaskAction = (()=>{
        setShowSubtaskModal(true)
    })
    const bulkCreateSubtaskAction = (()=>{
        setShowBulkSubtasksModal(true)
    })

    const createSubtaskCloseAction = (()=>{
        setShowSubtaskModal(false)
    })
    const bulkCreateSubtaskCloseAction = (()=>{
        setShowBulkSubtasksModal(false)
    })

    const createWorklogAction = (()=>{
        setShowWorklogModal(true)
    })
    const createWorklogCloseAction = (()=>{
        setShowWorklogModal(false)
    })

    const createTaskResourceAction = (()=>{
        setShowTaskResourceModal(true)
    })
    const createTaskResourceCloseAction = (()=>{
        setShowTaskResourceModal(false)
    })
    const startTaskAction =(async ()=>{
        await taskStart(task.id, changeStatusError)
        refreshProjectsCategory();
    })

    const finishTaskAction =(async ()=>{
        await taskFinish(task.id, changeStatusError)
        refreshProjectsCategory();
    })

    const cancelTaskAction =(async ()=>{
        await taskCancel(task.id, changeStatusError)
        refreshProjectsCategory();
    })


    const editTaskModal = (<TaskModal taskId={task.id} closeAction={editTaskCloseAction}></TaskModal>)
    const addSubtaskModal = (<SubtaskModal task={task} closeAction={createSubtaskCloseAction}></SubtaskModal>)
    const bulkAddSubtaskModal = (<BulkSubtaskModal task={task} closeAction={bulkCreateSubtaskCloseAction}></BulkSubtaskModal>)
    const addWorklogModal = (<WorklogModal task={task} closeAction={createWorklogCloseAction}></WorklogModal>)
    const addTaskResourceModal = (<TaskResourceModal task={task} closeAction={createTaskResourceCloseAction}></TaskResourceModal>)

    const changeStatusError = ((error)=>{
        showError(`Error al cambiar el estado de la tarea. ${error.message}`)

    })

    const renderDeadline =(()=>{
        if(isTaskFinished(task)||isTaskCancelled(task)) return
        const text = `(deadline ${moment(task.deadline).endOf('day').fromNow()})`
        return (
            <div className="font-bold text-l text-right ml-2 " 
            style={{ color: `${deadlineStatusEnum(task.deadlineStatus).color}`}} >{moment(task.deadline).endOf('day').fromNow()}</div>
        )
    })

    const toolbarIcons = (
        <ToolbarComponent className=''>
            <ToolbarOptionComponent title={'Editar'} size={20} icon={toolbarActions.Edit} clickAction={editTaskAction}/>
            <ToolbarOptionComponent title={'Iniciar'} size={20} icon={toolbarActions.Start} clickAction={startTaskAction}/>
            <ToolbarOptionComponent title={'Finalizar'} size={20} icon={toolbarActions.Finish} clickAction={finishTaskAction}/>
            <ToolbarOptionComponent title={'Cancelar'} size={20} icon={toolbarActions.Cancel} clickAction={cancelTaskAction}/>
        </ToolbarComponent>
    );

    const header = (
        <div className='flex flex-row'>

            <div className='flex flex-row justify-start text-xl'>
                <div className='px-2 rounded-md flex flex-row' style={{ backgroundColor: `${taskStatusEnum(task.status).color}`}}>
                    {task.name}
                    <div className='text-gray-400 text-right ml-2'>(#{task.subtasks.length})</div>
                    <div className='text-gray-400 text-right ml-2'>({taskSizesEnum(task.size).size})</div>
                </div>               
                
                {renderDeadline()}
                
            </div>
        </div>
      );

    const renderSubtasks = (task) => {
        if(task === undefined || task.subtasks === undefined) return
        const orderedSubtasks = [...task.subtasks].sort((a, b) => a.order - b.order)

        const handleSubtaskDrop = async (toIndex, draggedSubtaskId) => {
            const newOrder = toIndex
            try {
                await subtaskOrder(draggedSubtaskId, newOrder, (response) => {
                    refreshProjectsCategory()
                }, (error) => {
                    showError(`Error al reordenar la subtarea. ${error.message}`)
                })
                refreshProjectsCategory()
            } catch (error) {
                showError('Error al reordenar la subtarea')
            }
        }

        return orderedSubtasks.map((subtask, index) => (
            <div
                key={subtask.id}
                draggable
                onDragStart={() => {
                    setDragSubtaskId(subtask.id)
                    setIsSubtaskDragging(true)
                }}
                onDragOver={(e) => {
                    e.preventDefault()
                    if (dragSubtaskId && dragSubtaskId !== subtask.id) {
                        setDragOverSubtaskId(subtask.id)
                    }
                }}
                onDragLeave={() => setDragOverSubtaskId(null)}
                onDragEnd={() => {
                    setDragSubtaskId(null)
                    setDragOverSubtaskId(null)
                    setIsSubtaskDragOverTask(false)
                    setIsSubtaskDragging(false)
                }}
                onDrop={async (e) => {
                    e.preventDefault()
                    if (!dragSubtaskId || dragSubtaskId === subtask.id) return
                    await handleSubtaskDrop(index, dragSubtaskId)
                    setDragSubtaskId(null)
                    setDragOverSubtaskId(null)
                    setIsSubtaskDragOverTask(false)
                    setIsSubtaskDragging(false)
                }}
                className={`mb-2 ${dragOverSubtaskId === subtask.id ? 'ring-1 ring-blue-300 rounded-md' : ''}`}
            >
                <ExpandableSubtaskComponent
                    subtask={subtask}
                    expanded={expandedSubtaskId === subtask.id}
                    onToggle={(nextExpanded) => setExpandedSubtaskId(nextExpanded ? subtask.id : null)}
                />
            </div>
        ))
    }

    const renderWorklogs = (task) => {
        if(task === undefined || task.worklogs === undefined) return
        return task.worklogs.map((worklog) => (
            <WorklogComponent worklog={worklog}/>
        ))
    }

    const renderResources = (task) => {
        if(task === undefined || task.resources === undefined) return
        return task.resources.map((resource) => (
            <TaskResourceComponenet taskResource={resource}/>
        ))
    }

    return (
        
        <div key={task.id}  className=''>
            {showTaskModal && editTaskModal}
            {showSubtaskModal && addSubtaskModal}
            {showBulkSubtasksModal && bulkAddSubtaskModal}
            {showWorklogModal && addWorklogModal}
            {showTaskResourceModal && addTaskResourceModal}

            <ExpandablePanel key={task.id} header={header} toolbarIcons={toolbarIcons} expanded={expanded} onToggle={onToggle}>

                <Markdown 
                className='border-l-4 pl-2 pr-2 prose max-w-full max-h-60 overflow-y-scroll mb-2'
                remarkPlugins={[remarkGfm]}
                >
                    {task.richDescription}
                </Markdown>
                <div className='flex flex-col gap-3'>
                    <div className='p-3 rounded-md border border-gray-200 bg-white'>
                        <div className="flex flex-row items-center mb-2">
                            <div className='font-bold text-lg'>Subtareas</div>
                            <ToolbarComponent className='ml-2'>
                                <ToolbarOptionComponent title={'+ Subtarea'} size={20} icon={toolbarActions.AddSubtask} clickAction={createSubtaskAction}/>
                                <ToolbarOptionComponent title={'+ lista de Subtareas'} size={20} icon={toolbarActions.AddBulkSubtask} clickAction={bulkCreateSubtaskAction}/>
                            </ToolbarComponent>
                        </div>
                        <div
                            className={`${isSubtaskDragOverTask && isSubtaskDragging ? 'ring-1 ring-blue-200 bg-blue-50/50 rounded' : ''}`}
                            onDragOver={(e) => {
                                if (dragSubtaskId) {
                                    e.preventDefault()
                                    setIsSubtaskDragOverTask(true)
                                }
                            }}
                            onDragLeave={() => setIsSubtaskDragOverTask(false)}
                        >
                            {renderSubtasks(task)}
                        </div>
                    </div>

                    <div className="p-3 rounded-md border border-gray-200 bg-gray-50">
                        <div className="flex flex-row items-center mb-2">
                            <div className='font-bold text-lg'>Recursos</div>
                            <ToolbarComponent className='ml-2'>
                                <ToolbarOptionComponent title={'+ Recurso'} size={20} icon={toolbarActions.AddResource} clickAction={createTaskResourceAction}/>
                            </ToolbarComponent>
                        </div>
                        {renderResources(task)}
                    </div>

                    <div className="p-3 rounded-md border border-gray-200 bg-gray-50">
                        <div className='flex flex-row items-center mb-2'>
                            <div className='font-bold text-lg'>Carga de horas</div>
                            <ToolbarComponent className='ml-2'>
                                <ToolbarOptionComponent title={'+ horas'} size={20} icon={toolbarActions.AddWorklog} clickAction={createWorklogAction}/>
                            </ToolbarComponent>
                        </div>
                        {renderWorklogs(task)}
                    </div>
                </div>
            </ExpandablePanel>
        </div>

    )
}